import { makeStyles } from '@material-ui/core';
import theme from 'styles/theme';
import Colors from 'styles/colors';

const useStyles = makeStyles({
  clickableRow: {
    cursor: 'pointer',
  },
  table: {
    minWidth: 650,
  },
  paperTable: {
    marginTop: 18,
    padding: theme.spacing(1, 3, 3, 3),
    borderRadius: 30,
  },
  headerMargin: {
    marginBottom: theme.spacing(3),
  },
  containerMargin: {
    marginTop: theme.spacing(3),
  },
  boldText: {
    fontWeight: 'bold',
  },
  colorRed: {
    color: Colors.RED,
  },
  colorWhite: {
    color: Colors.WHITE,
  },
  menuOption: {
    textTransform: 'capitalize',
  },
  textFilter: {
    fontSize: '1.6rem',
    fontWeight: 'bold',
    textTransform: 'capitalize',
    width: '100%',
    textAlign: 'left',
  },
});

export { useStyles };
